import config from "@/config";
import { createInMemoryWebStorage } from "@/utils/inMemoryWebStorage";
import { WebStorageStateStore } from "oidc-client-ts";

// OIDC user (tokens) live in memory only — not sessionStorage. Full page reload requires login.
export const oidcUserMemoryStorage = createInMemoryWebStorage();

export const oidcUserStore = new WebStorageStateStore({
  store: oidcUserMemoryStorage,
});

export function getOidcUserStorageKey(): string {
  return `oidc.user:${config.oidc.authority}:${config.oidc.client_id}`;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function getPlaywrightOidcUserStorage(): unknown {
  if (typeof window === "undefined") return undefined;

  const descriptor = Object.getOwnPropertyDescriptor(
    window,
    "__PW_OIDC_USER_STORAGE__"
  );
  return descriptor?.value;
}

/** Playwright injects auth via `window.__PW_OIDC_USER_STORAGE__` before the app loads. */
export function seedPlaywrightOidcUserMemory(): void {
  const storage = getPlaywrightOidcUserStorage();
  if (!isRecord(storage)) return;

  for (const [key, value] of Object.entries(storage)) {
    if (!key.startsWith("oidc.user:")) continue;

    const stored = typeof value === "string" ? value : JSON.stringify(value);
    oidcUserMemoryStorage.setItem(key, stored);
  }
}

seedPlaywrightOidcUserMemory();
